<template>
  <div id="">
    <div class="emd-stripe">
      <div class="emd-bounds">
        <div class="emd-section">
          <div v-if="isLoading && !requestFailed" class="emd-box _state_loading"></div>
          <p v-else-if="!isLoading && requestFailed" class="emd-text _color_danger _align_center">{{$t('edit.error')}}</p>
          <div v-else class="emd-box">
            <EmdBoxHeader :title="$t('breadcrumb.edit.description')">
              <button class="emd-btn _color_secondary _type_text" v-show="disabled" @click="disabled = !disabled">{{$t('edit.edit')}}</button>
            </EmdBoxHeader>
            <div class="emd-box__content">
              <div class="emd-alert _color_success hideFeedback" ref="feedback">
                <p>{{$t('edit.form.description.success_message')}}</p>
              </div>
              <error-list :items="errors"></error-list>
              <form action="javascript:void(0)" ref="formDescriptions" @submit.prevent="saveDescriptions" novalidate="true">
                <fieldset>
                  <div class="emd-flex _column _row_md" v-for="(description, index) in descriptions" :key="index">
                    <div class="emd-flex-item _basis_12">
                      <div class="emd-chunk">
                          <label class="emd-label">{{description.language}}</label>
                      </div>
                    </div>
                    <div class="emd-flex-item _basis_12">
                      <div class="emd-chunk">
                        <div class="emd-form-group">
                          <label class="emd-label">{{$t('edit.form.description.resumed')}}</label>
                          <textarea class="emd-input" type="text" rows="5" @focus="sendShortDescToFsDependingOnLang" :disabled="disabled" v-model="description.short_description"> </textarea>
                          <p class="emd-input-helper">Caracteres: 200.</p>
                        </div>
                      </div>
                    </div>
                    <div class="emd-flex-item _basis_12">
                      <div class="emd-chunk">
                        <div class="emd-form-group" @click="sendDataToFsDependingOnLang(description)" disabled>
                          <label class="emd-label" disabled>{{$t('edit.form.description.app')}}</label>
                          <markdown-editor :configs="mdConfig" preview-class="markdown-body" ref="markdownEditor" v-model="description.full_description" :class="[disabled ? 'disabled' : '']"></markdown-editor>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <fieldset>
                  <div class="emd-flex _justify_space-between" v-show="!disabled">
                    <div class="emd-flex-item _grow_1">
                      <button class="emd-btn _color_secondary _type_text" type="button" v-if="showAddDescription">{{$t('edit.form.description.add')}}</button>
                    </div>
                    <div class="emd-flex-item">
                      <div class="emd-flex _justify_flex-end">
                        <div class="emd-flex-item _shrink">
                          <button class="emd-btn _color_primary _type_text" type="button" @click="disabled = !disabled">{{$t('edit.cancel')}}</button>
                        </div>
                        <div class="emd-flex-item _shrink">
                          <button class="emd-btn _color_secondary" type="submit" :disabled="!formIsValid">{{$t('edit.save')}}</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import markdownEditor from 'vue-simplemde'
import ErrorList from '@/components/project/ErrorList.vue'
import EmdBoxHeader from '@/components/emerald/EmdBoxHeader'
import sendFsCustomEvent from '@/mixins/sendFsCustomEvent'

export default {
  name: 'ApplicationDescriptions',
  components: {
    markdownEditor,
    ErrorList,
    EmdBoxHeader
  },
  mixins: [sendFsCustomEvent],
  computed: {
    isLoading () {
      return this.$store.state.application.detail.isLoading
    },
    requestFailed () {
      return this.$store.state.application.detail.requestFailed
    },
    showAddDescription () {
      return this.createRecursiveLang()
    },
    descriptions () {
      return this.$store.state.application.detail.descriptions
    }
  },
  data () {
    return {
      langs: ['pt-br', 'en-us'],
      disabled: true,
      formIsValid: true,
      mdConfig: {
        spellChecker: false
      },
      errors: []
    }
  },
  methods: {
    displayFeedback () {
      window.scrollTo(0, 0)
      this.$refs.feedback.classList.add('displayFeedback')
      this.$refs.feedback.classList.remove('hideFeedback')
      setTimeout(() => {
        this.$refs.feedback.classList.remove('displayFeedback')
        this.$refs.feedback.classList.add('hideFeedback')
      }, 2000)
    },
    saveDescriptions (e) {
      const elements = [...e.target.elements]
      const invalidElements = elements.filter(element => element.willValidate).filter(element => !element.checkValidity())
      if (invalidElements.length === 0) {
        const submitButton = elements.filter(e => e.type === 'submit')[0]
        submitButton.classList.add('_state_loading')
        this.$store.dispatch('UPDATE_DESCRIPTIONS', { descriptions: this.descriptions })
          .then(response => {
            this.errors = []
            this.disabled = true
            this.displayFeedback()
            submitButton.classList.remove('_state_loading')
          })
          .catch(response => {
            submitButton.classList.remove('_state_loading')
            if (response.status === 400) {
              this.errors = response.body.errors
            }
          })
      }
    },
    createRecursiveLang () {
      if (this.descriptions.length >= this.langs.length) {
        return false
      }
      const defaultLangs = this.descriptions.reduce((arr, item) => {
        arr.push(item.language)
        return arr
      }, [])
      const langs = this.langs.filter(e => !defaultLangs.includes(e))
      this.descriptions.push({ language: langs[0], short_description: undefined, full_description: undefined })
      return this.createRecursiveLang()
    },
    sendDataToFsDependingOnLang (description) {
      const appEvent = description.language === 'pt-br' ? 'descrição-completa' : 'descrição-completa-en'
      this.sendFsEvent(appEvent)
    },
    sendShortDescToFsDependingOnLang (description) {
      const appEvent = description.language === 'pt-br' ? 'descrição-resumida' : 'descrição-resumida-en'
      this.sendFsEvent(appEvent)
    }
  },
  updated () {
    this.formIsValid = this.$refs.formDescriptions.checkValidity()
  }
}
</script>
<style scoped>
  @import '~simplemde/dist/simplemde.min.css';
  @import '~github-markdown-css';

  .disabled {
    pointer-events: none;
  }
  .CodeMirror.cm-s-paper.CodeMirror-wrap {
    background-color: #c0c0c0;
  }
  .emd-box._state_loading {
    height: 610px;
    background-repeat: no-repeat;
    background-image:
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4),
      linear-gradient(#f4f4f4);
    background-size:
      15% 25px,
      14% 20px,
      97% 115px,
      97% 115px,
      14% 20px;
    background-position:
      1.59% 4.35%,
      1.59% 22.15%,
      49% 32%,
      49% 71.5%,
      1.59% 55.15%;
    opacity: 1;
    animation: opacity 1s infinite ease-in;
  }
</style>
